import {Component, ElementRef, ViewChild} from '@angular/core';

import { AlertController, NavController } from 'ionic-angular';
import { ModalController, ViewController,NavParams } from 'ionic-angular';



import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

declare var google: any;

@Component({
    selector: 'page-locationselect',
    templateUrl: 'location-select.html'
})
export class LocationSelectForm {

    term: any;
    jobList: any;
    queryText: string;
    data:any = {};
    addresses:any = [];

    constructor(
        public viewCtrl: ViewController,
        public params: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
    ) {
        this.addresses = [];
    }
    saveItem() {

    }
    ionViewDidLoad() {

        var that = this;
        var parentDOM = document.getElementById("ggsuggest");
        let input =  <HTMLInputElement>parentDOM.getElementsByClassName('searchbar-input')[0];
        // set the options
        let options = {
            types: [],
            componentRestrictions: {country: "fr"}
        };
        let autocomplete1 = new google.maps.places.Autocomplete(input, options);
        google.maps.event.addListener(autocomplete1, 'place_changed', function() {
            let place = autocomplete1.getPlace();
            let geometry = place.geometry;
            if ((geometry) !== undefined) {


            }
            that.processGooglePlaceData(place);
            that.dismiss();
        });
        var that = this;
        that.addresses = [];
        var that = this;
        this.userData.load().subscribe(user => {
            var searchFilters = this.userData.get('searchFilters');
            if(searchFilters && searchFilters.addresses)
            {
                Object.keys(searchFilters.addresses).forEach(arrKey => {
                    searchFilters.addresses[arrKey].index=arrKey;
                    that.addresses.push(searchFilters.addresses[arrKey]);
                });
            }
        });

        /*
        this.userData.getUserInformationsReference('searchFilters').subscribe(ref => {
            var searchFilters = this.userData.infos('searchFilters');
            if(searchFilters && searchFilters.addresses)
            {
                Object.keys(searchFilters.addresses).forEach(arrKey => {
                    searchFilters.addresses[arrKey].index=arrKey;
                    that.addresses.push(searchFilters.addresses[arrKey]);
                });
            }
        });*/


    }
    chooseFavAddress(address) {
        this.data = {
            'mode': 'favorite',
            'data': address
        };
        this.viewCtrl.dismiss(this.data);
    }
    processGooglePlaceData(data) {
        this.data = data;
    }
    dismiss() {
        this.viewCtrl.dismiss(this.data);
    }

}


// WEBPACK FOOTER //
// ./src/pages/utils/location-select/location-select.ts